module.exports = __webpack_public_path__ + "img/biz_logo_ES_movil.d857636d.png";